import { render, staticRenderFns } from "./gtr-course-contents.vue?vue&type=template&id=46959b1c&scoped=true&"
import script from "./gtr-course-contents.ts?vue&type=script&lang=ts&"
export * from "./gtr-course-contents.ts?vue&type=script&lang=ts&"
import style0 from "./gtr-course-contents.vue?vue&type=style&index=0&id=46959b1c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46959b1c",
  null
  
)

export default component.exports